import _ from 'lodash'
import moment from 'moment-mini'
import { PickerType } from './constants'
import { mixColor } from '../../core/utils/KColor'
import { primary as primaryColor, secondary as secondaryColor } from '../../scss/utilities/derived-variables.scss'

export default {
  name: 'KDatePickerCell',
  inject: ['context', 'picker'],
  props: {
    value: moment,
    referenceValue: moment,
  },
  data() {
    return {}
  },
  computed: {
    now() {
      return this.context.now
    },
    disabledDate() {
      return this.context.disabledDate
    },
    pickerType() {
      return this.picker.pickerType
    },
    selectedValue() {
      return this.multiple ? this.picker.selectedDate : this.context.value
    },
    startValue() {
      return this.picker.startValue
    },
    endValue() {
      return this.picker.endValue
    },
    hoveredValue() {
      return this.picker.hoveredCell && this.picker.hoveredCell.value
    },
    date() {
      return this.value.format('D')
    },
    belongCurrentMonth() {
      return this.referenceValue.month() === this.value.month()
    },
    isToday() {
      return this.value.isSame(this.now, 'day')
    },
    disabled() {
      if (this.disabledDate) {
        return this.disabledDate(this.value.clone())
      }
      return false
    },
    multiple() {
      return this.context.multiple
    },
  },
  watch: {},
  created() {
  },
  methods: {
    getCssAndStyle() {
      const hovered = this.value.isSame(this.hoveredValue, 'day')

      const css = {
        'km-date-picker__cell': true,
        'km-date-picker__cell--silent': !this.belongCurrentMonth,
        'km-date-picker__cell--now': this.isToday,
        'km-date-picker__cell--disabled': this.disabled,
        'km-date-picker__cell--hovered': hovered,
      }
      const style = {}

      if (!this.belongCurrentMonth) {
        return {
          css,
        }
      }

      if (this.pickerType === PickerType.Date) {
        let isSelected = false
        if (_.isArray(this.selectedValue)) {
          isSelected = _.some(this.selectedValue, item => {
            return item && item.isSame(this.value, 'day')
          })
        } else {
          isSelected = this.selectedValue && this.selectedValue.isSame(this.value, 'day')
        }
        _.assign(css, {
          'km-date-picker__cell--active': isSelected,
        })
      } else if (this.pickerType === PickerType.DateRange) {
        const cellRangeCss = {
          'km-date-picker__cell--start': this.startValue && this.value.isSame(this.startValue, 'day'),
          'km-date-picker__cell--end': this.endValue && this.value.isSame(this.endValue, 'day'),
        }

        if (hovered) {
          _.assign(cellRangeCss, {
            'km-date-picker__cell--start-selected': !!this.startValue && !this.endValue,
            'km-date-picker__cell--end-selected': !!this.endValue && !this.startValue,
          })
        }

        const cellRangeStyle = this.getCellRangeStyle()
        if (cellRangeStyle) {
          _.assign(cellRangeCss, {
            'km-date-picker__cell--between': true,
          })
        }

        _.assign(css, cellRangeCss)
        _.assign(style, cellRangeStyle)
      }

      return {
        css,
        style,
      }
    },
    getCellRangeStyle() {
      const { startValue, endValue, hoveredValue, value } = this
      let durationDiff = 0
      let durationStart
      let durationEnd
      let valueDiff
      if (startValue && endValue) {
        durationDiff = endValue.diff(startValue, 'days')
        durationStart = startValue.clone().add(1, 'days')
        durationEnd = endValue.clone().subtract(1, 'days')
        valueDiff = value.diff(startValue, 'days')
      } else if (startValue && hoveredValue) {
        durationDiff = hoveredValue.diff(startValue, 'days')
        durationStart = startValue.clone().add(1, 'days')
        durationEnd = hoveredValue.clone().subtract(1, 'days')
        valueDiff = value.diff(startValue, 'days')
      } else if (endValue && hoveredValue) {
        durationDiff = endValue.diff(hoveredValue, 'days')
        durationStart = hoveredValue.clone().add(1, 'days')
        durationEnd = endValue.clone().subtract(1, 'days')
        valueDiff = value.diff(hoveredValue, 'days')
      } else {
        return
      }
      if (valueDiff > 0 && value.isBetween(durationStart, durationEnd, 'days', '[]')) {
        const from = mixColor(secondaryColor, primaryColor, (valueDiff - 1) / durationDiff)
        const to = mixColor(secondaryColor, primaryColor, valueDiff / durationDiff)
        if (from && to) {
          const style = {
            color: `rgb(${to.r}, ${to.g}, ${to.b})`,
            // backgroundImage: `linear-gradient(to right, rgb(${from.r}, ${from.g}, ${from.b}), rgb(${to.r}, ${to.g}, ${to.b}))`,
            // color: 'white',
          }
          return style
        }
      }
    },
    getEvents() {
      const events = {
        click: () => {
          if (this.disabled) {
            return
          }
          this.picker.handleCellClick(this)
        },
        mouseenter: () => {
          if (this.disabled) {
            return
          }
          this.picker.handleCellHover(this)
        },
        mouseleave: () => {
          this.picker.handleCellLeave(this)
        },
      }

      return events
    },
  },
  render() {
    const { css, style } = this.getCssAndStyle()
    const events = this.getEvents()

    const data = {
      class: css,
      on: events,
    }

    return (
      <div {...data}>
        <div class="km-date-picker__cell-inner">
        {
          this.$scopedSlots.default
            ? this.$scopedSlots.default({ value: this.date, date: this.value.valueOf(), selectedValue: this.selectedValue })
            : <span
              class="km-date-picker__cell-value"
              style={style}
            >
              {this.date}
            </span>
        }
        </div>
      </div>
    )
  },
}
